"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePlayerStatus = void 0;
var react_1 = require("react");
var keys_1 = require("../keys");
var useQuery_1 = require("../useQuery");
var useLevels_1 = require("./useLevels");
var user_1 = require("../user");
var usePlayerStatus = function () {
    var _a, _b, _c, _d, _e;
    var isAuth = (0, user_1.useIsAuthorized)();
    var _f = (0, useQuery_1.useQuery)({
        canRender: isAuth,
        path: keys_1.MY_LEVEL_PROGRESS,
        revalidateOnMount: true,
        shouldRetryOnError: false,
    }), myProgress = _f.data, isLoading = _f.isLoading;
    var levels = (0, useLevels_1.useLevels)().data;
    var firstLevelWithAward = (0, react_1.useMemo)(function () { return levels === null || levels === void 0 ? void 0 : levels.find(function (level) { return !level.newbie; }); }, [levels]);
    var currentLevelInfo = (0, react_1.useMemo)(function () {
        var _a;
        if (levels && ((_a = myProgress === null || myProgress === void 0 ? void 0 : myProgress.data) === null || _a === void 0 ? void 0 : _a.currentLevel))
            return levels === null || levels === void 0 ? void 0 : levels[(myProgress.data.currentLevel || 0) - 1];
    }, [(_a = myProgress === null || myProgress === void 0 ? void 0 : myProgress.data) === null || _a === void 0 ? void 0 : _a.currentLevel, levels]);
    var nextLevelInfo = (0, react_1.useMemo)(function () {
        var _a;
        if (levels && ((_a = myProgress === null || myProgress === void 0 ? void 0 : myProgress.data) === null || _a === void 0 ? void 0 : _a.currentLevel))
            return levels === null || levels === void 0 ? void 0 : levels[myProgress.data.currentLevel || 0];
    }, [(_b = myProgress === null || myProgress === void 0 ? void 0 : myProgress.data) === null || _b === void 0 ? void 0 : _b.currentLevel, levels]);
    var progressPercents = (0, react_1.useMemo)(function () {
        var _a;
        var userCurrentPoints = Number(((_a = myProgress === null || myProgress === void 0 ? void 0 : myProgress.data) === null || _a === void 0 ? void 0 : _a.totalExp) || 0);
        var currentLevelPoints = Number((currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.fromPoints) || 0);
        var nextLevelPoints = Number((nextLevelInfo === null || nextLevelInfo === void 0 ? void 0 : nextLevelInfo.fromPoints) || 1);
        var pointsInCurrentLevel = userCurrentPoints > currentLevelPoints
            ? userCurrentPoints - currentLevelPoints
            : userCurrentPoints;
        var currentLevelMaxPoints = nextLevelPoints - 1 - currentLevelPoints;
        var percents = (pointsInCurrentLevel || 0) / currentLevelMaxPoints;
        return Math.round(percents * 100);
    }, [(_c = myProgress === null || myProgress === void 0 ? void 0 : myProgress.data) === null || _c === void 0 ? void 0 : _c.totalExp, currentLevelInfo, nextLevelInfo]);
    return {
        userPoints: ((_d = myProgress === null || myProgress === void 0 ? void 0 : myProgress.data) === null || _d === void 0 ? void 0 : _d.totalExp)
            ? Math.round(Number((_e = myProgress === null || myProgress === void 0 ? void 0 : myProgress.data) === null || _e === void 0 ? void 0 : _e.totalExp))
            : 0,
        levelMaxPoints: (nextLevelInfo === null || nextLevelInfo === void 0 ? void 0 : nextLevelInfo.fromPoints)
            ? Number(nextLevelInfo === null || nextLevelInfo === void 0 ? void 0 : nextLevelInfo.fromPoints) - 1
            : null,
        nextLevelMin: Number(nextLevelInfo === null || nextLevelInfo === void 0 ? void 0 : nextLevelInfo.fromPoints),
        progressPercents: progressPercents ? progressPercents : 0,
        currentLevelInfo: currentLevelInfo ? currentLevelInfo : null,
        nextLevelInfo: nextLevelInfo ? nextLevelInfo : null,
        isLoading: isLoading,
        firstLevelWithAward: firstLevelWithAward,
    };
};
exports.usePlayerStatus = usePlayerStatus;
